import { WARN_LEVEL } from "./consolaLogLevels";
const getConsoleFunction = (level) => {
    if (level < WARN_LEVEL)
        return console.error;
    if (level === WARN_LEVEL)
        return console.warn;
    return console.log;
};
/**
 * @example
 * // "[spicychat:module=useRecombee:error] Error in errorHandler", error
 */
const plainConsoleReporter = {
    log(logObj) {
        const consoleFunction = getConsoleFunction(logObj.level);
        // Consola omits the type for plain `log` calls, matching BrowserReporter.
        const type = logObj.type === "log" ? "" : logObj.type;
        const label = [logObj.tag, type].filter(Boolean).join(":");
        const prefix = label ? `[${label}]` : "";
        if (!prefix) {
            consoleFunction(...logObj.args);
            return;
        }
        const [firstArg, ...restArgs] = logObj.args;
        if (typeof firstArg === "string") {
            consoleFunction(`${prefix} ${firstArg}`.trim(), ...restArgs);
            return;
        }
        consoleFunction(prefix, firstArg, ...restArgs);
    },
};
export default plainConsoleReporter;
